/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { CreateOrderOptions, CreateOrderResponses } from '../types/CreateOrder'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Create a new order
 * {@link /v1/orders}
 */
export function createOrder<ThrowOnError extends boolean = true>(
  options: Options<CreateOrderOptions, ThrowOnError>,
): Unwrappable<RequestResult<CreateOrderResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/orders',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CreateOrderResponses, ThrowOnError>>,
  )
}
